/**
 * Banners popup component
 *
 * @module app/components/banners/BannersAddToSlip
 */
import jQuery from 'jquery';
import MessageBusTopics from '../../../common/MessageBusTopics';

/**
 * Reference to the betslipApi, assigned during init().
 * @type {[type]}
 */
var betslipApi;

export default {

    /**
     * Binds event handlers to banner elements.
     *
     * @returns {void}
     *
     * @private
     */
    bindEvents: function bindEvents() {

        this.bindHandler();

        window.WH.messageBus.subscribe(MessageBusTopics.NAVIGATION_PAGE_CHANGED, function () {
            this.bindHandler();
        }.bind(this));
    },

    bindHandler: function () {

        jQuery('.banners-container button.oddsbutton')
            .off()
            .on(
                'click',
                this.handleBannerAddToSlip.bind(this)
            );
    },

    /**
     * Create string of attributes in the format -
     * data-trk-gametype|data-trk-position|data-trk-banner-ID|data-trk-carousel-index
     *
     * @param {object} attributes The DOM element attributes from the banner button
     *
     * @returns {string} trackingAttributes Concatenated string of tracking attributes
     *
     * @private
     */
    createTrackingAttribute: function createTrackingAttribute(attributes) {

        let position = attributes['data-trk-position'] ? attributes['data-trk-position'].value : 1;

        var trackingAttributes = [
            attributes['data-trk-gametype'].value,
            position,
            attributes['data-trk-banner-id'].value,
            attributes['data-trk-carousel-index'].value,
        ];

        return trackingAttributes.join('|');
    },

    /**
     *
     * @param {Object} e jquery normalized event based on the browser native
     * event object.
     *
     * @TODO - openBetslip removed as it causes bigger issues when triggered in desktop view.
     *
     * @returns {void}
     *
     * @private
     */
    handleBannerAddToSlip: function handleBannerAddToSlip(e) {

        var bannerButton = e.currentTarget;
        var trackingAttribute = this.createTrackingAttribute(bannerButton.attributes);
        this.publishAddedToSlipFromBanner(trackingAttribute);

    },

    /**
     * Perform initialisation.
     *
     * @returns {void}
     *
     * @public
     */
    init: function init() {

        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_INIT_COMPLETE, function () {
            if (window.whStatic.config.enableBannersAddToSlipBetSlipAPI && window.document.sportsbookAPI){
                betslipApi = window.document.sportsbookAPI.betslipAPI;
            }
        }.bind(this));

        this.bindEvents();
    },

    /**
     * Checks whether the selection we're about to add is already
     * in the slip so we can prevent firing add to slip again
     * which causes the selection to be removed
     *
     * @param {string} selectionId Selection ID
     *
     * @returns {boolean} isAlreadyInSlip Flag to indicate if selection is in slip
     *
     * @private
     */
    isAlreadyInSlip: function isAlreadyInSlip(selectionId) {
        if (betslipApi) {
            var betslipResponse = betslipApi.getBets();

            if (betslipResponse[0]) {
                var betslipData = JSON.parse(betslipResponse[1]);
                var ids = betslipData.singles.map(function (single) {
                    /*jshint -W106 */
                    return single.ev_oc_id;
                    /*jshint +W106 */
                });

                return ids.indexOf(selectionId) !== -1;
            }
        }

        return false;
    },

    /**
     *
     * @param {string} trackingAttribute Tracking Attribute
     *
     * @returns {void}
     *
     * @private
     */
    publishAddedToSlipFromBanner: function publishAddedToSlipFromBanner(trackingAttribute) {

        window.WH.messageBus.publish(MessageBusTopics.BANNER_SELECTION_ADDED, { 'addedFrom': trackingAttribute });
    },

};


